import React from "react";
import { WrongWay } from "./WrongWay";

/**
 * Componente que ayuda a contener los archivos y redirigirlos a otro componente.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, errorInfo);
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <WrongWay />;
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
